<div class="sgt-cliente-analise-mercado-rap-view sgt-view-block">
    <sgt-cliente-analise-mercado-rap-form-table
        #formTable
        [revisaoMode]="props.revisaoMode"
        [filter]="props.filter">
    </sgt-cliente-analise-mercado-rap-form-table>
</div>